import OtoIndividualGuard from '../../components/guards/oto-individual-guard'
import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { OtoIndividualPlacePeriodsListPage } from './oto-individual-place-periods-list'
import { OtoIndividualPlacesListPage } from './oto-individual-places-list'

const otoIndividualPlacesRoutes: Route[] = [
  {
    // the role list alone cannot express it: only a prestataire flagged as One to One Individuel
    // reaches these pages, so the guard mirrors the navbar condition
    element: <OtoIndividualGuard />,
    children: [
      {
        path: Paths.OTO_INDIVIDUAL_PLACE_PERIODS_LIST_PAGE,
        element: <OtoIndividualPlacePeriodsListPage />,
        roles: [RoleEnum.ADMIN, RoleEnum.Ol]
      },
      {
        path: Paths.OTO_INDIVIDUAL_PLACES_BY_PERIOD_LIST_PAGE,
        element: <OtoIndividualPlacesListPage />,
        roles: [RoleEnum.ADMIN, RoleEnum.Ol]
      }
    ]
  }
]

export default otoIndividualPlacesRoutes
